<template>
  <div class="container-fluid text-left">
    <div class="row center-block">
      <div class="col-sm-2" style="margin: 20px 0;"></div>
      <div class="col-sm-8" style="margin: 20px 0;">
        <div id="surveyContainer">
          <survey :survey="survey">
          </survey>
        </div>
      </div>
    </div>
    <el-dialog
      title="Fragen Suchen"
      :visible.sync="searchPageVisible"
      width="100%">
      <div class="questionSearch">
        <v-autocomplete
          :items="items"
          v-model="item"
          :get-label="getLabel"
          @update-items="update"
          :component-item="template"
          @item-clicked="itemClicked"
          :input-attrs="{name: 'input-test', id: 'v-my-autocomplete', autofocus:true, placeholder: 'Begriffe eingeben'}"
          :auto-select-one-item="false">
        </v-autocomplete>
      </div>
    </el-dialog>
    <div class="surveyMenu">
      <el-dropdown split-button type="warning" size="medium" @command="gotoPage" @click="searchPageVisible=!searchPageVisible">
        <i class="el-icon-search" style="margin-right: 10px"></i>Suche
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(page, index) in survey_pages" :key="index" :command="index">{{ page.title }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="col-sm-2" style="margin: 20px 0;"></div>
  </div>
</template>

<script>
import * as SurveyVue from 'survey-vue'
import service from '@/utils/request.js'
import Questions from '@/utils/avcheck_questions'
import Autocomplete from 'v-autocomplete'
import QuestionList from './QuestionList.vue'

var Survey = SurveyVue.Survey
const failed = 'ff0000'
const passed = '00ff00'
export default {
  name: 'SurveyContent',
  components: {
    Survey,
    'v-autocomplete': Autocomplete
    // ckeditor : CKEditor.component
  },
  props: ['id', 'surveyJSON', 'hightlight_terms', 'customerName', 'customerAddress', 'partnerName', 'partnerAddress', 'filename', 'auftragsgeber', 'surveyData'],
  data: function() {
    var model = new SurveyVue.Model(this.surveyJSON)
    var survey_menu = this.surveyJSON['pages']
    // Survey.cssType = 'bootstrap'
    var myCss = {
      'question': {
        'title': 'questiontitle',
        'hasError': 'has-error'
      },
      'navigationButton': 'button btn-lg',
      'error': {
        'root': 'alert alert-danger',
        'icon': 'glyphicon glyphicon-exclamation-sign',
        'item': '',
        'locationTop': 'sv_qstn_error_top',
        'locationBottom': 'sv_qstn_error_bottom'
      }
    }
    const that = this
    if (this.surveyData) {
      model.data = JSON.parse(this.surveyData)
    }
    model.onCompleting.add(
      function(sender, options) {
        if (!that.surveyConfirmed) {
          options.allowComplete = that.completeOption
          that.resultBody = JSON.stringify(sender.data)
          that.organizeResult(JSON.stringify(sender.data))
          that.dialogVisible = true
        }
      }
    )
    model.onValueChanged.add(
      function(sender, options) {
        const survey_result = sender.data
        const key = 'av_' + that.$store.getters.id
        localStorage.setItem(key + '.data', JSON.stringify(survey_result))
        localStorage.setItem(key + '.modifed', Date.now().toLocaleString())
      }
    )
    model.onComplete.add(function(result) {
      // that.resultBody = JSON.stringify(result.data);
      // that.submitResult()
    })
    model.css = myCss
    model.completedHtml = '<p><h4>Danke für die Prüfung.</h4></p>'
    model.showPageTitles = true
    model.clearInvisibleValues = 'onHidden'
    return {
      survey: model,
      survey_pages: survey_menu,
      search_keywords: '',
      searchPageVisible: false,
      loading: true,
      dialogVisible: false,
      completeOption: false,
      surveyConfirmed: false,
      reportDate: Date.now(),
      auditResult: 'passed',
      generalComment: {
        gegendstandComment: 'k.A.',
        umfangComment: 'k.A.',
        ortComment: 'k.A.',
        verantwortlichenrechtComment: 'k.A.',
        auftragsverarbeiterpflichtComment: 'k.A.',
        tomsComment: 'k.A.',
        unterauftragComment: 'k.A.'
      },
      // editor: ClassicEditor,
      surveyComment: '',
      item: {},
      items: [],
      template: QuestionList,
      surveyResponse: {},
      resultBody: {},
      resultOverview: {
        'gegenstand': 0,
        'umfang': 0,
        'ort': 0,
        'verantwortlichenrecht': 0,
        'auftragsverarbeiterpflicht': 0,
        'toms': 0,
        'unterauftrag': 0

      },
      resultRelation: {
        'gegenstand': 'gegenstand',
        'dauer': 'gegenstand',
        'hauptvertrag': 'umfang',
        'weisung': 'umfang',
        'verwendungszweck': 'umfang',
        'datenarten': 'umfang',
        'personkreis': 'umfang',
        'ort': 'ort',
        'weisungsrecht': 'verantwortlichenrecht',
        'kontrollrechten': 'verantwortlichenrecht',
        'melden': 'verantwortlichenrecht',
        'meldfrist': 'verantwortlichenrecht',
        'bestellungspflicht': 'auftragsverarbeiterpflicht',
        'vertraulichkeit': 'auftragsverarbeiterpflicht',
        'betroffenenauskunft': 'auftragsverarbeiterpflicht',
        'loeschen': 'auftragsverarbeiterpflicht',
        'zulaessigkeit': 'unterauftrag',
        'wie': 'unterauftrag',
        'genehmigung': 'unterauftrag',
        'kontrollerechtenunterauftragnehmer': 'unterauftrag',
        'tomsvertraulichkeit': 'toms',
        'integritaet': 'toms',
        'belastbarkeit': 'toms',
        'verfuegbarkeit': 'toms',
        'wiederherstellung': 'toms',
        'tomskontrolle': 'toms'
      },
      organizedResult: {
        'gegenstand': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'content': []
        },
        'umfang': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'content': []
        },
        'ort': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'content': []
        },
        'verantwortlichenrecht': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'content': []
        },
        'auftragsverarbeiterpflicht': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'content': []
        },
        'toms': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'content': []
        },
        'unterauftrag': {
          'color': passed,
          'points': 0,
          'comment': 'k. A.',
          'content': []
        }
      },
      resultDesc: {
        'gegenstand': {
          'no': 'Es gibt keine Regelung zum Gegenstand des Vertrages.',
          'yes': 'Es gibt eine Regelung zum Gegenstand des Vertrages.',
          'ref': ''
        },
        'dauer': {
          'no': 'Beginn und Ende des Auftrages sind nicht im Vertrag geregelt.',
          'yes': 'Beginn und Ende des Auftrages sind im Vertrag geregelt',
          'ref': ''
        },
        'hauptvertrag': {
          'no': 'Die Inhalte ergeben sich nicht aus dem Leistungsvertrag/Hauptvertrag.',
          'yes': 'Die Inhalte ergeben sich aus dem Leistungsvertrag/Hauptvertrag.',
          'ref': ''
        },
        'weisung': {
          'no': 'Es gibt keine konkrete Weisungen, welche Verarbeitungen vom Auftragnehmer vorzunehmen sind.',
          'yes': 'Es gibt konkrete Weisungen, welche Verarbeitungen vom Auftragnehmer vorzunehmen sind.',
          'ref': ''
        },
        'verwendungszweck': {
          'no': 'Der Verwendungszweck ist nicht im Vertrag geregelt.',
          'yes': 'Der Verwendungszweck ist im Vertrag geregelt.',
          'ref': ''
        },
        'datenarten': {
          'no': 'Die Datenarten sind nicht vertraglich festgehalten oder bestimmt bzw. bestimmbar.',
          'yes': 'Die Datenarten sind vertraglich festgehalten oder bestimmt bzw. bestimmbar.',
          'ref': ''
        },
        'personkreis': {
          'no': 'Der Kreis der betroffenen Personen ist nicht dem Vertrag zu entnehmen.',
          'yes': 'Der Kreis der betroffenen Personen ist dem Vertrag zu entnehmen.',
          'ref': ''
        },
        'ort': {
          'no': 'Der geografische Ort (Land) der Auftragsverarbeitung ist nicht definiert.',
          'yesitem1': 'Die Auftragsverarbeitung darf ausschließlich in einem Mitgliedsstaat der Europäischen Union oder in einem anderen Vertragsstaat des Abkommens über den Europäischen Wirtschaftsraum erfolgen.',
          'yesitem2': 'Jede Auftragsverarbeitung außerhalb eines Mitgliedsstaates der Europäischen Union oder außerhalb eines anderen Vertragsstaates des Abkommens über den Europäischen Wirtschaftsraum (im folgenden „Drittland“) bedarf der vorherigen Zustimmung des Auftraggebers.',
          'yesitem3': 'Die Auftragsverarbeitung außerhalb eines Mitgliedsstaates der Europäischen Union oder außerhalb eines anderen Vertragsstaates des Abkommens über den Europäischen Wirtschaftsraum (im folgenden „Drittland“) erfolgt über folgende Sicherheiten (bspw. Standardvertragsklauseln, verbindliche interne Datenschutzvorschriften, Angemessenheitsbeschluss der EU-Kommission o. ä.)..',
          'ref': ''
        },
        'weisungsrecht': {
          'no': 'Es gibt keine Regelung, aus der sich der Umfang des Weisungsrechts des Aufraggebers (ggf. auch hinsichtlich der Zulässigkeit ergänzender Weisungen („Weisungsvorbehalt“) ergibt.',
          'yes': 'Es gibt eine Regelung, aus der sich der Umfang des Weisungsrechts des Aufraggebers (ggf. auch hinsicht-lich der Zulässigkeit ergänzender Weisungen („Weisungsvorbehalt“) ergibt.',
          'ref': ''
        },
        'kontrollrechten': {
          'no': 'Es gibt keine Regelung zu Kontrollrechten des Auftraggebers.',
          'yes': 'Es gibt eine Regelung zu Kontrollrechten des Auftraggebers.',
          'ref': ''
        },
        'melden': {
          'no': 'Es gibt keine Regelung, aus der sich die Pflicht des Auftragnehmers ergibt, Verstöße gegen Datenschutzvorschriften (insbesondere der DSGVO) oder gegen die vom Auftraggeber erteilten Weisungen zu melden.',
          'yes': 'Es gibt eine Regelung, aus der sich die Pflicht des Auftragnehmers ergibt, Verstöße gegen Datenschutzvorschriften (insbesondere der DSGVO) oder gegen die vom Auftraggeber erteilten Weisungen zu melden.',
          'ref': ''
        },
        'meldfrist': {
          'no': 'Im Vertrag ist keine Frist geregelt, binnen derer der Auftragnehmer nach Kenntnis eines Datenschutzvorfalls eine Meldung gegenüber dem Auftraggeber zu machen hat.',
          'yes': 'Im Vertrag ist eine Frist geregelt, binnen derer der Auftragnehmer nach Kenntnis eines Datenschutzvorfalls eine Meldung gegenüber dem Auftraggeber zu machen hat.',
          'ref': ''
        },
        'bestellungspflicht': {
          'noitem': 'Für den Auftragnehmer ist kein Datenschutzbeauftragter angegeben.',
          'yesitem1': 'Kontaktdaten des DSB werden dem Auftraggeber zum Zweck der direkten Kontaktaufnahme mitgeteilt. Ggf. Auskunft auf folgende Art und Weise.',
          'yesitem2': 'Es ist festgelegt, dass ein Wechsel des Datenschutzbeauftragten dem Auftraggeber unverzüglich mitgeteilt wird.',
          'yesitem3': 'Der Auftragnehmer hat seinen Sitz außerhalb der Union und benennt einen Vertreter nach Art. 27 Abs. 1 DSGVO in der Union',
          'yesitem4': 'Der Auftragnehmer ist nicht zur Bestellung eines Datenschutzbeauftragten verpflichtet. Als Ansprechpartner beim Auftragnehmer ist ein Ansprechpartner benannt',
          'ref': ''
        },
        'vertraulichkeit': {
          'no': 'Es gibt keine Regelung zur Verpflichtung der Beschäftigten des Auftragnehmers zur Vertraulichkeit.',
          'yes': 'Es gibt eine Regelung zur Verpflichtung der Beschäftigten des Auftragnehmers zur Vertraulichkeit.',
          'ref': ''
        },
        'betroffenenauskunft': {
          'no': 'Im Vertrag ist die Zusammenarbeit bzw. Unterstützung des Auftraggebers durch den Auftragnehmer bei Geltendmachung der Rechte der betroffenen Personen nicht geregelt.',
          'yes': 'Im Vertrag ist die Zusammenarbeit bzw. Unterstützung des Auftraggebers durch den Auftragnehmer bei Geltendmachung der Rechte der betroffenen Personen geregelt.',
          'ref': ''
        },
        'loeschen': {
          'no': 'Es gibt keine Regelung, aus der sich die Pflicht des Auftragnehmers ergibt, überlassene Datenträger zurückzugeben bzw. für den Auftraggeber gespeicherte Daten zu löschen.',
          'yes': 'Es gibt eine Regelung, aus der sich die Pflicht des Auftragnehmers ergibt, überlassene Datenträger zurückzugeben bzw. für den Auftraggeber gespeicherte Daten zu löschen.',
          'ref': ''
        },
        'zulaessigkeit': {
          'no': 'Es gibt keine Regelung zur Zulässigkeit von Unterauftragsverhältnissen.',
          'yes': 'Es gibt eine Regelung zur Zulässigkeit von Unterauftragsverhältnissen.',
          'ref': ''
        },
        'wie': {
          'no': 'Es gibt keine Regelung dazu, wie der Unterauftragnehmer zu beauftragen ist.',
          'yes': 'Es gibt eine Regelung dazu, wie der Unterauftragnehmer zu beauftragen ist.',
          'ref': ''
        },
        'genehmigung': {
          'no': 'Es gibt keine Regelung dazu, wie neue Unterauftragnehmer vom Auftraggeber zu genehmigen sind bzw. im Falle einer allgemeinen Genehmigung, dass neue Unterauftragnehmer dem Auftraggeber im Voraus benannt werden und dem Auftraggeber ein Widerspruchsrecht zusteht.',
          'yes': 'Es gibt eine Regelung dazu, wie neue Unterauftragnehmer vom Auftraggeber zu genehmigen sind bzw. im Falle einer allgemeinen Genehmigung, dass neue Unterauftragnehmer dem Auftraggeber im Voraus benannt werden und dem Auftraggeber ein Widerspruchsrecht zusteht.',
          'ref': ''
        },
        'kontrollerechtenunterauftragnehmer': {
          'no': 'Es gibt keine Regelung zu Kontrollrechten des Auftraggebers gegenüber etwaigen Unterauftragnehmern.',
          'yes': 'Es gibt eine Regelung zu Kontrollrechten des Auftraggebers gegenüber etwaigen Unterauftragnehmern.',
          'ref': ''
        },
        'tomsvertraulichkeit': {
          'no': 'Es gibt keine Regelung zur Gewährleistung der Vertraulichkeit.',
          'yes': 'Es gibt Regelungen zur Gewährleistung der Vertraulichkeit.',
          'ref': ''
        },
        'integritaet': {
          'no': 'Es gibt keine Regelung zur Gewährleistung der Integrität.',
          'yes': 'Es gibt Regelungen zur Gewährleistung der Integrität.',
          'ref': ''
        },
        'belastbarkeit': {
          'no': 'Es gibt keine Regelung zur Gewährleistung der Belastbarkeit der Systeme auf Dauer.',
          'yes': 'Es gibt Regelungen zur Gewährleistung der Belastbarkeit der Systeme auf Dauer.',
          'ref': ''
        },
        'verfuegbarkeit': {
          'no': 'Es gibt keine Regelung zur Gewährleistung der Verfügbarkeit.',
          'yes': 'Es gibt Regelungen zur Gewährleistung der Verfügbarkeit.',
          'ref': ''
        },
        'wiederherstellung': {
          'no': 'Es gibt keine Regelung zur Fähigkeit des Auftragsverarbeiters, die Verfügbarkeit der personenbezogenen Daten und den Zugang zu ihnen bei einem physischen oder technischen Zwischenfall rasch wiederherzustellen.',
          'yes': 'Es gibt Regelungen zur Fähigkeit des Auftragsverarbeiters, die Verfügbarkeit der personenbezogenen Daten und den Zugang zu ihnen bei einem physischen oder technischen Zwischenfall rasch wiederherzustellen.',
          'ref': ''
        },
        'tomskontrolle': {
          'no': 'Es gibt keine Regelung dazu, wie der Auftragsverarbeiter die regelmäßige Überprüfung, Bewertung und Evaluierung der Wirksamkeit der technischen und organisatorischen Maßnahmen zur Gewährleistung der Sicherheit der Verarbeitung gewährleistet.',
          'yes': 'Es gibt Regelungen dazu, wie der Auftragsverarbeiter die regelmäßige Überprüfung, Bewertung und Evaluierung der Wirksamkeit der technischen und organisatorischen Maßnahmen zur Gewährleistung der Sicherheit der Verarbeitung gewährleistet.',
          'ref': ''
        }
      }
    }
  },
  mounted() {
    this.save_local()
  },
  methods: {
    itemClicked: async function(item) {
      const goto_page = this.survey.getPageByName(item.category)
      this.survey.currentPage = goto_page
      this.survey.getQuestionByName(item.name).focus()
      this.searchPageVisible = false
    },
    getLabel: function(item) {
      if (item) {
        return item.title
      }
      return ''
    },
    update: function(text) {
      this.items = Questions.filter((item) => {
        return (new RegExp(text.toLowerCase())).test(item.title.toLowerCase())
      })
    },
    gotoPage: function(command) {
      this.survey.currentPageNo = command
    },
    save_local: function() {
      const key = 'av_' + this.$store.getters.id
      localStorage.setItem(key + '.id', this.id)
      localStorage.setItem(key + '.customerName', this.customerName)
      localStorage.setItem(key + '.customerAddress', this.customerAddress)
      localStorage.setItem(key + '.partnerName', this.partnerName)
      localStorage.setItem(key + '.partnerAddress', this.partnerAddress)
      localStorage.setItem(key + '.filename', this.filename)
      localStorage.setItem(key + '.auftragsgeber', this.auftragsgeber)
      localStorage.setItem(key + '.status', 'processing')
      localStorage.setItem(key + '.modifed', new Date().toLocaleString())
    },
    hinweiseChange: function(event) {
      if (event.target.checked === true) {
        this.organizedResult[event.target.name]['comment'] = 'Bitte auf Hinweise achten'
      } else {
        this.organizedResult[event.target.name]['comment'] = 'k.A.'
      }
    },
    closeDiaglog: function() {
      this.dialogVisible = false
    },
    confirmResult: function() {
      this.submitResult()
      this.completeOption = true
      this.dialogVisible = false
      this.surveyConfirmed = true
      this.survey.doComplete()
      const key = 'av_' + this.$store.getters.id
      localStorage.setItem(key + '.status', 'completed')
      localStorage.setItem(key + '.modifed', Date.now().toLocaleString())
    },
    submitResult: function() {
      var uploadResult = {
        survey: this.id,
        customerName: this.customerName,
        customer_name: this.customerName,
        customerAddress: this.customerAddress,
        contract_name: this.filename,
        partnerName: this.partnerName,
        partnerAddress: this.partnerAddress,
        auftragsgeber: this.auftragsgeber,
        result_body: this.resultBody,
        // sorted_result: JSON.stringify({'resultOverview':this.resultOverview, 'overviewComment': this.generalComment, 'organizedResult': this.organizedResult, 'auditResult': this.auditResult}),
        sorted_result: JSON.stringify({ 'organizedResult': this.organizedResult, 'auditResult': this.auditResult, 'auditComment': this.surveyComment }),
        document_url: this.filename,
        createdby: this.$store.getters.id
      }
      const that = this
      service.request({
        url: '/survey/v1/surveyresult/',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: uploadResult
      }).then(function(response) {
        that.$message({ message: 'Fertig hochgeladen', type: 'success' })
        that.surveyResponse = response.data
        that.$router.push({ name: 'confirmav', params: { surveyResponse: that.surveyResponse }})
      }).catch(function(err) {
        console.log(err)
      })
    },
    answerNotify: function(title, msg) {
      const h = this.$createElement
      this.$notify({
        title: title,
        message: h('i', { style: 'color: teal' }, msg)
      })
    },
    handleClose: function(done) {
      done()
    },
    organizeResult: function(surveyResult) {
      const that = this
      Object.keys(this.organizedResult).forEach(function(key) {
        that.organizedResult[key].points = 0
        that.organizedResult[key].content = []
      })
      const resultList = JSON.parse(surveyResult)
      // console.log(resultList);
      // console.log(this.organizedResult['gegenstand'].result);
      var overviewKey = ''
      var tempObj = {}
      Object.keys(resultList).forEach(function(key) {
        // console.log(key);
        overviewKey = that.resultRelation[key]
        if (overviewKey) {
          if (key === 'bestellungspflicht') {
            if (resultList[key] === 'no') {
              that.auditResult = 'failed'
              that.organizedResult[overviewKey].color = failed
              tempObj = { 'title': key, 'color': failed, 'result': 'failed', 'comment': that.resultDesc[key].noitem, 'ref': '' }
              that.organizedResult[overviewKey].content.push(tempObj)
            } else {
              // overviewKey = that.resultRelation[key];
              // that.resultOverview[overviewKey] = that.resultOverview[overviewKey] + 1;
              that.organizedResult[overviewKey].points += 1
              tempObj = { 'title': key, 'color': passed, 'result': 'passed', 'comment': '', 'ref': '' }
              if (resultList['Genaue Geschreibung DSB'] === 'item1') {
                tempObj['comment'] = that.resultDesc[key].yesitem1
              } else if (resultList['Genaue Geschreibung DSB'] === 'item2') {
                tempObj['comment'] = that.resultDesc[key].yesitem2
              } else if (resultList['Genaue Geschreibung DSB'] === 'item3') {
                tempObj['comment'] = that.resultDesc[key].yesitem3
              } else {
                tempObj['comment'] = that.resultDesc[key].yesitem4
              }
              tempObj['ref'] = resultList['Genaue Geschreibung DSB-Comment']
              that.organizedResult[overviewKey].content.push(tempObj)
            }
          } else if (key === 'ort') {
            if (resultList[key] === 'no') {
              that.auditResult = 'failed'
              that.organizedResult[overviewKey].color = failed
              tempObj = { 'title': key, 'color': failed, 'result': 'failed', 'comment': that.resultDesc[key].no, 'ref': '' }
              that.organizedResult[overviewKey].content.push(tempObj)
            } else {
              that.organizedResult[overviewKey].points += 1
              tempObj = { 'title': key, 'color': passed, 'result': 'passed', 'comment': '', 'ref': '' }
              if (resultList['Genaue Beschreibung'] === 'item1') {
                tempObj['comment'] = that.resultDesc[key].yesitem1
              } else if (resultList['Genaue Beschreibung'] === 'item2') {
                tempObj['comment'] = that.resultDesc[key].yesitem2
              } else {
                tempObj['comment'] = that.resultDesc[key].yesitem3
              }
              tempObj['ref'] = resultList['Genaue Beschreibung-Comment']
              that.organizedResult[overviewKey].content.push(tempObj)
            }
          } else if (key === 'hauptvertrag') {
            if (resultList[key] === 'other') {
              that.organizedResult[overviewKey].points = 4
              tempObj = { 'title': key, 'color': passed, 'result': 'passed', 'comment': that.resultDesc[key].yes, 'ref': '' }
              const refkey = key + '-Comment'
              tempObj['ref'] = resultList[refkey]
              that.organizedResult[overviewKey].content.push(tempObj)
            }
          } else {
            if (resultList[key] === 'other') {
              that.organizedResult[overviewKey].points += 1
              tempObj = { 'title': key, 'color': passed, 'result': 'passed', 'comment': that.resultDesc[key].yes, 'ref': '' }
              const refkey = key + '-Comment'
              tempObj['ref'] = resultList[refkey]
              that.organizedResult[overviewKey].content.push(tempObj)
            } else {
              that.auditResult = 'failed'
              that.organizedResult[overviewKey].color = failed
              tempObj = { 'title': key, 'color': failed, 'result': 'failed', 'comment': that.resultDesc[key].no, 'ref': '' }
              that.organizedResult[overviewKey].content.push(tempObj)
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '../../assets/css/survey.css';
  #surveyContainer {
    font-family: Tahoma, Helvetica, Arial, sans-serif;
    text-align: left;
    font-size: 0.8rem;
}
  .questiontitle {
    font-size: 1rem;
  }
  .radio {
    font-size: 0.6rem;
  }
  .sv_q_erbox {
    background-color: red;
    color: red;
  }
  table {
  font-family: 'Tahoma', arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

  td, th {
  border: 1px solid black;
  text-align: center;
  padding: 8px;
}

  tr:nth-child(even) {
  background-color: #dddddd;
}
  .ired {
    color: red
  }
  .igreen {
    color: green
  }
  h5.dialogtitle {
    color: #7a4c28;
    font-weight: bold;
  }
  .sv_p_root > .sv_row {
    border-bottom: 1px solid #92be05;
  }
  .sv_p_root > .sv_row:nth-child(odd) {
      background-color: white;
    }

  .sv_p_root > .sv_row:nth-child(even) {
    background-color: #ebeef5;
  }
  .sv_p_root > .sv_page_title {
    font-weight: 900;
  }
  .surveyMenu {
    position: fixed;
    top: 80px;
    right: 20px;
  }
  .v-autocomplete
  .v-autocomplete-input-group
    .v-autocomplete-input
      font-size 1.5em
      padding 10px 15px
      box-shadow none
      border 1px solid #157977
      width 100%
      outline none
      background-color #eee
    &.v-autocomplete-selected
      .v-autocomplete-input
        color green
        background-color #f2fff2
  .v-autocomplete-list
    width 100%
    text-align left
    border none
    border-top none
    max-height 400px
    overflow-y auto
    border-bottom 1px solid #157977
    .v-autocomplete-list-item
      cursor pointer
      background-color #fff
      padding 10px
      border-bottom 1px solid #157977
      border-left 1px solid #157977
      border-right 1px solid #157977
      &:last-child
        border-bottom: none
      &:hover
        background-color #eee
      abbr
        opacity 0.8
        font-size 0.8em
        display block
        font-family sans-serif
  pre
    text-align left
    white-space pre-wrap
    background-color #eee
    border 1px solid silver
    padding 20px !important
    border-radius 10px
    font-family monospace !important
  .left
    text-align left
  .note
    border-left 5px solid #ccc
    padding 10px
</style>
